// src/api/enquiryApi.js
import axios from './axios';

// Generic handler
const postEnquiry = async (type, data) => {
  try {
    const response = await axios.post(type, data);

    if (response.status === 200 || response.status === 201) {
      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Enquiry submitted successfully',
      };
    } else {
      return {
        success: false,
        message: `Unexpected response status: ${response.status}`,
      };
    }
  } catch (error) {
    // Handle known error structure
    if (error.response) {
      return {
        success: false,
        status: error.response.status,
        message: error.response.data?.message || 'Something went wrong on the server.',
      };
    } else if (error.request) {
      return {
        success: false,
        message: 'No response from server. Please check your network.',
      };
    } else {
      return {
        success: false,
        message: `Error: ${error.message}`,
      };
    }
  }
};

// Specific wrappers
export const submitSponsorshipEnquiry = (data) => postEnquiry('sponsorship-enquiry', data);
export const submitDelegateEnquiry = (data) => postEnquiry('participant-enquiry', data);
